import React from 'react';

export interface LoadBufferContextProps {
  registerLoader?: (options: { resourceId: number; name: string }) => void;
  unregisterLoader?: (options: { resourceId: number; name: string}) => void;
}

const LoadBufferContext = React.createContext<LoadBufferContextProps>({});

export default LoadBufferContext;
